import React from 'react';
import SearchFormTabsLandscape from '../SearchFormTabsLandscape';
/**
 * Landing custom header
 * 
 * @author Luciano Bustos
 */
class ResultsHeader extends React.Component {
    render() {
        return (<div className="cmsResultsHeader">
            <SearchFormTabsLandscape />
        </div>
        );
    }
}

export default (ResultsHeader);


// WEBPACK FOOTER //
// ./src/cms/headers/ResultsHeader.js